import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Habitacion } from '@core/model/habitacion.model';
import * as EstadoType from '@core/model/habitacion.model';

import * as moment from 'moment';

@Component({
  selector: 'app-card-room',
  templateUrl: './card-room.component.html',
  styleUrls: ['./card-room.component.css']
})
export class CardRoomComponent implements OnInit {
  // @Input() data: Habitacion;
  @Input() data: any;
  @Output() clickAsignar = new EventEmitter<Habitacion>();
  @Output() clickDetalle = new EventEmitter<Habitacion>();
  @Output() clickTerminar = new EventEmitter<Habitacion>();
  @Output() clickPago = new EventEmitter<Habitacion>();
  @Output() clickMantenimiento = new EventEmitter<Habitacion>();
  @Output() clickReserva = new EventEmitter<Habitacion>();
  @Output() clickServicio = new EventEmitter<Habitacion>();

  // EstadoType = EstadoType;
  estadoType: EstadoType.EstadoType;

  // private habitacionesGet: Observable<any>;
  public fecha: moment.Moment;
  textFormattime = '';
  diffDays: number;
  diffHours: number;

  constructor() {
    // this.habitacionesGet = habitacionService.getById('1');
    // this.data.
    // const now = moment(); // add this 2 of 4
    // console.log('hello world', now.format());
    // this.fecha = this.data.estado.registro.fecha_fin;
  }

  ngOnInit(): void {
    const now = moment();
    if (this.data.estado.estado === 'OCUPADO') {
      this.fecha = moment(this.data.estado.registro.fecha_fin);
      this.diffDays = this.fecha.diff(now, 'days');
      this.diffHours = this.fecha.diff(now, 'hours');
      if (this.diffDays < 0) {
        this.textFormattime = this.data.estado.registro.fecha_fin;
      } else {
        this.textFormattime =
          `Faltan ${this.diffDays} d. ${this.diffDays * 24 - this.diffHours} ` +
          'h.';
      }
    }
  }

  getRoomClass(data: any): string {
    const estado = data?.estado?.estado?.toLowerCase() || 'disponible';
    return estado;
  }

  getHeaderClass(data: any): string {
    return this.getRoomClass(data);
  }

  getStatusClass(data: any): string {
    return this.getRoomClass(data);
  }

  getFooterClass(data: any): string {
    return this.getRoomClass(data);
  }
}
